import React, {useEffect, useState} from 'react';
import PropTypes from 'prop-types';
import {useAuthUser} from './AuthHooks';
import AppLoader from '../core/AppLoader';
import {useLocation, useNavigate} from 'react-router-dom';
import axios from 'axios';
import Api from '@api';

const profileApiMap = {
  EMPLOYEE: Api.employee.list,
  MANAGER: Api.employee.list,
  CORPORATEADMIN: Api.onBoardCorporate.list,
  TENANTADMIN: Api.onBoardTenant.list,
  VENDOR: Api.vendor.list,
  DRIVER: Api.driver.list,
};

const AuthRoutes = ({children}) => {
  const {isLoading, user} = useAuthUser();
  const navigate = useNavigate();
  const location = useLocation();
  const [profileChecked, setProfileChecked] = useState(false);

  useEffect(() => {
    if (isLoading) return;
    if (!user?.userList?.profileId || !user?.userList?.userRole) {
      setProfileChecked(true);
      return;
    }
    const apiBase = profileApiMap[user.userList.userRole];
    if (!apiBase) {
      setProfileChecked(true);
      return;
    }
    axios
      .get(`${apiBase}/${user.userList.profileId}`)
      .then((res) => {
        if (
          res?.data?.data?.profileStatus === 'DEFAULT' &&
          location.pathname !== '/my-profile' &&
          location.pathname !== '/my-profile-update-request'
        ) {
          navigate('/my-profile');
        }
      })
      .catch(() => {})
      .finally(() => setProfileChecked(true));
  }, [isLoading, user?.userList?.profileId]);

  if (
    localStorage.getItem('token') &&
    localStorage.getItem('tripid') &&
    location.pathname != '/live-tracking-dashboard/default'
  ) {
    navigate('/live-tracking-dashboard/default');
    return;
  }

  return isLoading || !profileChecked ? <AppLoader /> : <>{children}</>;
};

export default AuthRoutes;

AuthRoutes.propTypes = {
  children: PropTypes.node.isRequired,
};
